export default __webpack_public_path__ + "static/media/challenge-banner.53a37243.png";